import React from 'react';
import { Route } from '../Routing/types';
import {
  CartAddMDSPage,
  PaymentMethodsMDSPage,
  CartSignUpMDSPage,
  CartLoginMDSPage,
  ThankYouMDSPage,
  SavePaymentMDSPage,
} from '@front-activerse/modules';
import { externalWebView } from '@front-activerse/common-components';
import {
  PATH_CART_ADD,
  PATH_CART_LOGIN,
  PATH_CART_SIGNUP,
  PATH_CART_PAYMENT_METHODS,
  PATH_CART_THANK_YOU,
  PATH_CART_SAVE_PAYMENT,
  PATH_CART_LOGIN_CHANGE_ACCOUNT,
  PATH_CART_SIGNUP_CHANGE_ACCOUNT,
} from './paths';

const isExternamWebView = externalWebView();

const routes: Route[] = [
  {
    path: PATH_CART_PAYMENT_METHODS,
    element: (
      <PaymentMethodsMDSPage
        pathThankYou={PATH_CART_THANK_YOU}
        pathPaymentMethods={PATH_CART_PAYMENT_METHODS}
      />
    ),
    private: false,
    title: 'route-title/cart',
  },
  {
    path: PATH_CART_SIGNUP,
    element: (
      <CartSignUpMDSPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        loginButtonURL={PATH_CART_LOGIN}
        action="cart_register"
        redirectToPathAfterSuccessFromRoute={PATH_CART_SAVE_PAYMENT}
      />
    ),
    private: false,
    title: 'route-title/buy',
  },
  {
    path: PATH_CART_SIGNUP_CHANGE_ACCOUNT,
    element: (
      <CartSignUpMDSPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        loginButtonURL={PATH_CART_LOGIN_CHANGE_ACCOUNT}
        action="cart_register"
        redirectToPathAfterSuccessFromRoute={PATH_CART_SAVE_PAYMENT}
      />
    ),
    private: false,
    title: 'route-title/buy',
  },
  {
    path: PATH_CART_LOGIN,
    element: (
      <CartLoginMDSPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        registerButtonURL={PATH_CART_SIGNUP}
        action="cart_login"
        redirectToPathAfterSuccessFromRoute={PATH_CART_SAVE_PAYMENT}
      />
    ),
    private: false,
    title: 'route-title/cart',
  },
  {
    path: PATH_CART_LOGIN_CHANGE_ACCOUNT,
    element: (
      <CartLoginMDSPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        registerButtonURL={PATH_CART_SIGNUP_CHANGE_ACCOUNT}
        action="cart_login"
        redirectToPathAfterSuccessFromRoute={PATH_CART_SAVE_PAYMENT}
      />
    ),
    private: false,
    title: 'route-title/cart',
  },
  {
    path: PATH_CART_ADD,
    element: (
      <CartAddMDSPage
        pathCartSignUp={PATH_CART_SIGNUP}
        pathCartSavePayment={PATH_CART_SAVE_PAYMENT}
      />
    ),
    private: false,
    title: 'route-title/cart',
  },
  {
    path: PATH_CART_THANK_YOU,
    element: <ThankYouMDSPage pathPaymentMethods={PATH_CART_PAYMENT_METHODS} />,
    private: false,
    title: 'route-title/cart',
  },
  {
    path: PATH_CART_SAVE_PAYMENT,
    element: <SavePaymentMDSPage pathPaymentMethods={PATH_CART_PAYMENT_METHODS} />,
    private: true,
    title: 'route-title/cart',
  },
];

export default routes;
